import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

/* eslint-disable no-new */
const store = new Vuex.Store({
  state: {
    Echo: null,
    loadingEcho: true,
    token: null,
    user: null,
    auth: null,
    loading: false,
    snackbarStatus: false,
    screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop',
    snackbarText: '',
    snackbarColor: 'success',
  },
  getters: {},
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setAdmin(state, admin) {
      state.admin = admin;
    },
    setAuth(state, status) {
      state.auth = status
    },
    setLoading(state, condition) {
      state.loading = condition
    },
    setSnackbarStatus(state, snackbarStatus) {
      state.snackbarStatus = snackbarStatus;
    },
    setSnackbarText(state, snackbarText) {
      state.snackbarText = snackbarText;
    },
    setSnackbarColor(state, snackbarColor) {
      state.snackbarColor = snackbarColor;
    },
  },
  actions: {},
  plugins: [],
  modules: {
  }
})

export default store
